var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStep(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 9,
    viewBox: "0 0 12 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6819 0.72895C11.4723 0.51618 11.1923 0.400024 10.8937 0.400024C10.6028 0.400024 10.3271 0.512923 10.1187 0.717009L4.69084 6.05581L1.87706 3.33213C1.66972 3.1313 1.39724 3.01949 1.1074 3.01949C0.806696 3.01949 0.52445 3.13781 0.312765 3.35493C0.106508 3.56661 -0.00421922 3.84669 0.000123025 4.14196C0.00446528 4.43832 0.124963 4.71514 0.336647 4.92031L3.92552 8.39519C4.13286 8.59711 4.40642 8.70783 4.69627 8.70783C4.9872 8.70783 5.26184 8.59711 5.47244 8.39085L11.6688 2.29542C11.8805 2.08916 11.9978 1.81234 11.9999 1.51707C12.0032 1.22071 11.8903 0.94172 11.6819 0.72895Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep);
export default __webpack_public_path__ + "static/media/step.9d0692995dc9aa49966809ba86012b29.svg";
export { ForwardRef as ReactComponent };